declare namespace $ {

	type $mol_view__sub_shm_hitalama_taskmanager_column_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_hitalama_taskmanager_column_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_column['task_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_hitalama_textarea__value_shm_hitalama_taskmanager_column_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_column['raw'] >
		,
		ReturnType< $shm_hitalama_textarea['value'] >
	>
	type $shm_hitalama_textarea__hint_shm_hitalama_taskmanager_column_4 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_textarea['hint'] >
	>
	type $mol_button_minor__hint_shm_hitalama_taskmanager_column_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_taskmanager_column_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_column['task_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_taskmanager_column_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_shm_hitalama_taskmanager_column_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_shm_hitalama_taskmanager_column_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_column['raw_open'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_taskmanager_column_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_taskmanager_column_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_taskmanager_column_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_column['raw_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_major__title_shm_hitalama_taskmanager_column_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_taskmanager_column_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_column['raw_save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $shm_hitalama_taskmanager_card__task_shm_hitalama_taskmanager_column_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_column['task'] >
		,
		ReturnType< $shm_hitalama_taskmanager_card['task'] >
	>
	export class $shm_hitalama_taskmanager_column extends $mol_page {
		count_label( ): string
		Count( ): $mol_view
		head_tools( ): readonly(any)[]
		task_rows( ): readonly($mol_view)[]
		Tasks( ): $mol_list
		raw( next?: string ): string
		Raw( ): $shm_hitalama_textarea
		column_body( ): readonly(any)[]
		task_add( next?: any ): any
		Add_icon( ): $mol_icon_plus
		raw_open( next?: any ): any
		Raw_open_icon( ): $mol_icon_code_braces
		raw_cancel( next?: any ): any
		raw_save( next?: any ): any
		task( id: any, next?: any ): any
		status( ): string
		tasks( next?: readonly(any)[] ): readonly(any)[]
		raw_opened( next?: boolean ): boolean
		attr( ): ({ 
			'shm_hitalama_taskmanager_column_status': ReturnType< $shm_hitalama_taskmanager_column['status'] >,
		})  & ReturnType< $mol_page['attr'] >
		title_content( ): readonly(any)[]
		tools( ): ReturnType< $shm_hitalama_taskmanager_column['head_tools'] >
		body( ): ReturnType< $shm_hitalama_taskmanager_column['column_body'] >
		Add( ): $mol_button_minor
		Raw_open( ): $mol_button_minor
		Raw_cancel( ): $mol_button_minor
		Raw_save( ): $mol_button_major
		Task( id: any): $shm_hitalama_taskmanager_card
	}
	
}

//# sourceMappingURL=column.view.tree.d.ts.map